import React from 'react';
import _startCase from 'lodash/startCase';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getLatestActivitySet } from 'lib/selectors/getLatestActivitySet';
import { getLatestSetupActivity } from 'lib/selectors/getLatestSetupActivity';
import { getUnitDurationFromString } from 'lib/utils/date';
import { getAdjustedSetupDurationDates } from 'lib/selectors/getAdjustedSetupDurationDates';
import { getIsPaused } from 'lib/selectors/getIsPaused';
import { WheelLabel, WheelSublabel } from '@m12s/component-library';
import { DurationTicker } from 'components/DurationTicker';
import { getIsJobLaborTrackingEnabled } from 'lib/selectors/getIsJobLaborTrackingEnabled';
import { InSetupDisplayText } from 'components/Text';
import { getJobStatus } from 'lib/selectors/getJobStatus';
import { getHasOpenActivitySetInSetup } from 'lib/selectors/getHasOpenActivitySetInSetup';
import { JOB_STATUSES } from 'lib/constants';
import { SETUP_ELAPSED_DURATION_TICKER_PROPS } from 'lib/utils/setupDurationDisplay';
import { PausedWheelContent } from './PausedWheelContent';
import { OpRunOverrideRejectLabel } from './OpRunOverrideRejectLabel';

export const WheelContentOpRunOverride = ({ isOvertime }) => {
  const { t } = useTranslation();

  const jobStatus = useSelector(getJobStatus);
  const hasOpenActivitySetInSetup = useSelector(getHasOpenActivitySetInSetup);
  const isSetup = hasOpenActivitySetInSetup || jobStatus === JOB_STATUSES.SETUP;

  const isJobLaborTrackingEnabled = useSelector(getIsJobLaborTrackingEnabled);
  const latestActivitySet = useSelector(getLatestActivitySet);
  const latestSetupActivity = useSelector(getLatestSetupActivity);
  const { expectedSetupDuration } = latestActivitySet;
  const expectedSetupDurationMs = getUnitDurationFromString(
    expectedSetupDuration,
    'milliseconds'
  );
  const { expectedSetupEndDate } = useSelector(getAdjustedSetupDurationDates);
  const isPaused = useSelector(getIsPaused);
  if (isPaused) {
    return (
      <PausedWheelContent expectedSetupDurationMs={expectedSetupDurationMs} />
    );
  }

  return (
    <>
      {!!expectedSetupDurationMs && (
        <>
          <WheelLabel>
            <DurationTicker
              reverse={!isOvertime}
              startDate={expectedSetupEndDate}
              endDateOverride={isPaused ? latestSetupActivity.end : null}
              {...SETUP_ELAPSED_DURATION_TICKER_PROPS}
            />
          </WheelLabel>
          <WheelSublabel>
            {_startCase(t(isOvertime ? 'overtime' : 'remaining'))}
          </WheelSublabel>
        </>
      )}

      {isJobLaborTrackingEnabled && !expectedSetupDurationMs && isSetup && (
        <InSetupDisplayText />
      )}
      <OpRunOverrideRejectLabel
        expectedSetupDurationMs={expectedSetupDurationMs}
      />
    </>
  );
};
